import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  theme => ({
    root: {
      padding: theme.spacing(2, 3)
    },
    title: {
      marginLeft: theme.spacing(-1),
      marginRight: theme.spacing(3),
      color: theme.palette.text.secondary,
      textAlign: 'left',
      fontWeight: 500
    },
    formGroup: {
      marginTop: theme.spacing(1)
    },
    formControl: {},
    checkbox: {
      padding: 0,
      width: theme.spacing(4),
      height: theme.spacing(4)
    },
    checkboxRoot: {},
    checked: {},
    label: {
      marginLeft: theme.spacing(1),
      color: theme.palette.text.primary
    }
  }),
  { name: 'MUIDataTableViewCol' }
);
